export const computerviren_indices =
    []
;